import { ReactNode } from "react";
import { Box } from "@mui/material";
import { useCustomColors } from "../hooks/useCustomColors";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const colors = useCustomColors();
  // The page atmosphere lives in background.gradient; this wrapper stays flat
  // so the two never stack into a visible band.
  const ambient = colors.background.canvas;

  return (
    <Box
      sx={{
        background: ambient,
        display: "flex",
        flexDirection: "column",
        animation: "float 20s ease-in-out infinite",
        color: colors.isDark ? "white" : colors.text.primary,
        height: "100vh",
        overflowY: "auto",
        // This box IS the page scroller, so its horizontal scrollbar would sit at
        // the viewport bottom and follow vertical scrolling. Inner wrappers scroll
        // sideways on their own instead.
        overflowX: "hidden",
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          background: ambient,
          width: "100%",
          animation: "float 20s ease-in-out infinite",

          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          minWidth: 0,
          minHeight: "100vh",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
